var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoFaTokenIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "twoFaTokenIco_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.454902 0 0 0 0 0.741176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#twoFaTokenIco_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.96 7.571c4.27 0 7.762 3.429 8.024 7.758l.016.524v21.294c0 4.398-3.328 7.995-7.531 8.265l-.509.017H77.527v-5.762H95.96c1.248 0 2.277-.961 2.428-2.204l.02-.316V15.853c0-1.285-.934-2.345-2.14-2.5l-.308-.02H77.527V7.57H95.96z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.065 0a5.352 5.352 0 015.353 5.351V47.65A5.352 5.352 0 0174.065 53H5.353A5.352 5.352 0 010 47.649V5.35A5.352 5.352 0 015.353 0h68.712zm-.359 5.706H5.708V47.29h67.998V5.706z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 9.464c8.877 0 16.073 7.204 16.073 16.09 0 8.885-7.196 16.089-16.073 16.089s-16.073-7.204-16.073-16.09c0-8.885 7.196-16.089 16.073-16.089z",
    fill: "#0074BD"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 15.24c-5.584 0-10.167 4.588-10.167 10.314 0 5.725 4.583 10.313 10.167 10.313s10.167-4.588 10.167-10.313c0-5.726-4.583-10.314-10.167-10.314z",
    stroke: "#FFF",
    strokeWidth: 2
  }))));
}
export default SvgTwoFaTokenIco;